import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import InsertChart from '@mui/icons-material/InsertChart';
import ReportsFilters from './ReportsFilters';
import ReportsList from './ReportsList';
import { Card } from '@totalsoft/rocket-ui';
import PaginationWrapper from 'components/common/PaginationWrapper';
import debounce from 'lodash.debounce';
import { loadReports } from '../../actions/actionCreators/reportsActions';
import { getReports, getReportsLoading, getReportTotalCount } from '../../selectors/reports';
import WrappedFakeText from 'components/common/WrappedFakeText';

const defaultPager = {
  page: 1,
  pageSize: 10
};

const defaultFilters = {
  reportName: ''
};

const DEBOUNCE_DELAY = 500;

class ReportsCardContainer extends PureComponent {
  state = {
    inEditFilters: null
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState.inEditFilters) return { inEditFilters: nextProps.filters };

    return null;
  }

  componentDidMount() {
    const { filters, page, pageSize } = this.props;
    this.props.actions.loadReports(filters, page, pageSize);
  }

  componentDidUpdate(prevProps) {
    const { filters, page, pageSize } = this.props;

    if (prevProps.filters !== this.props.filters || prevProps.page !== page || prevProps.pageSize !== pageSize) {
      this.props.actions.loadReports(filters, page, pageSize);
    }
  }

  filterChangedDebounced = debounce(this.props.pushFilters, DEBOUNCE_DELAY);

  onFilterValueChanged = (name, value, debounced) => {
    this.setState(
      currentState => {
        return {
          ...currentState,
          inEditFilters: { ...currentState.inEditFilters, [name]: value }
        };
      },
      () => {
        if (debounced) this.filterChangedDebounced(this.state.inEditFilters);
        else this.props.pushFilters(this.state.inEditFilters);
      }
    );
  };

  resetFilters = () => {
    this.setState({ inEditFilters: defaultFilters }, () => {
      this.props.pushFilters(this.state.inEditFilters);
    });
  };

  //TODO refresh
  onRefresh = () => {};

  render() {
    const { inEditFilters } = this.state;
    const { onFilterValueChanged, onRefresh, resetFilters } = this;
    const { page, pageSize, totalCount, onChangePage, onChangeRowsPerPage, reportsLoading, reports } = this.props;

    return (
      <Card icon={InsertChart}>
        <ReportsFilters filters={inEditFilters} onFilterValueChanged={onFilterValueChanged} resetFilters={resetFilters} />
        {reportsLoading ? <WrappedFakeText lines={pageSize} my={2} /> : <ReportsList reports={reports} />}
        <PaginationWrapper
          count={totalCount}
          pageSize={pageSize}
          page={page}
          onRefresh={onRefresh}
          onPageChange={onChangePage}
          onRowsPerPageChange={onChangeRowsPerPage}
        />
      </Card>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { page, pageSize, filters } = ownProps;

  const reports = getReports(filters, page, pageSize, state);
  const reportsLoading = getReportsLoading(filters, page, pageSize, state);
  const totalCount = getReportTotalCount(filters, pageSize, state);

  return {
    reports,
    reportsLoading,
    totalCount
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadReports }, dispatch)
  };
}

ReportsCardContainer.propTypes = {
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
  reportsLoading: PropTypes.bool.isRequired,
  reports: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
  pushFilters: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired
};

const ReportsCardContainerConnected = connect(mapStateToProps, mapDispatchToProps)(ReportsCardContainer);

class ReportsCardContainerLocalState extends PureComponent {
  state = {
    filters: { ...defaultFilters },
    ...defaultPager
  };

  pushFilters = filters => {
    this.setState({
      filters: { ...filters },
      page: 1
    });
  };

  onChangePage = page => {
    this.setState({ page: page + 1 });
  };

  onChangeRowsPerPage = pageSize => {
    this.setState({ pageSize, page: 1 });
  };

  render() {
    return (
      <ReportsCardContainerConnected
        {...this.props}
        {...this.state}
        pushFilters={this.pushFilters}
        onChangePage={this.onChangePage}
        onChangeRowsPerPage={this.onChangeRowsPerPage}
      />
    );
  }
}

export default ReportsCardContainerLocalState;
